import { render, staticRenderFns } from "./UserAccountModal.vue?vue&type=template&id=3125e1b8"
import script from "./UserAccountModal.vue?vue&type=script&lang=js"
export * from "./UserAccountModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports